import React from "react";
import SharedCommentsRoot from 'Main/containers/SharedCommentsRoot';

const SharedCommentsModule = props => <SharedCommentsRoot {...props} />;

export default SharedCommentsModule;
